import classnames from 'classnames';
import React from 'react';
import AnimateReveal from '../AnimateReveal/AnimateReveal';
import Section, { themes } from '../UI/Section/Section';
import * as styles from './SplitBody.module.scss';

const SplitBody = ({ children, aside, isAsideOffset = false, ...other }) => {
  const className = classnames(styles.container, {
    [ styles.isAsideOffset ]: isAsideOffset,
  });

  return (
    <Section theme={themes.DEFAULT} {...other}>
      <div className={className}>
        <AnimateReveal className={styles.main}>{children}</AnimateReveal>
        <div className={styles.aside}>{aside}</div>
      </div>
    </Section>
  );
};

export default SplitBody;
